import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import EngagementService from "../../Services/Engagement.service";
import AdvisorService from "../../Services/Advisor.service";
import useService from "../Hooks/useService";
import CaseloadKeyEngagementWidget from "../Presentational/Widgets/CaseloadKeyEngagementWidget";
import PersonTypeDomainService from "../../Domain/PersonType/PersonType.service";
import CoachService from "../../Services/Coach.service";
const PAGE_SIZE = 5;
const CaseloadKeyEngagementContainer = () => {
    const [caseloadModalFilterResponse, loadCaseloadModalFilterResponse] = useService(EngagementService.getCaseloadModalFilters);
    const [studentsByEngagementDateResponse, loadStudentsByEngagementDateResponse,] = useService(EngagementService.getStudentsByEngagementDate);
    const saveModalFilter = useService(EngagementService.setCaseloadModalFilters)[1];
    const [allStudentsByEngagementDateResponse, getAllStudentsByEngagementDateResponse,] = useService(EngagementService.getAllStudentsByEngagementDate);
    const [filterSettings, setFilterSettings] = React.useState({
        lastKeyEngagementMaxDaysAgo: 30,
        registrationTerms: [],
    });
    const [modalFilterSettings, setModalFilterSettings] = React.useState({
        lastKeyEngagementMaxDaysAgo: 30,
        registrationTerms: [],
    });
    const [termToRepresentAdvisorState, loadTermToRepresentAdvisor] = useService(AdvisorService.getTermForAdvisor);
    const [termToRepresentCoachState, loadTermToRepresentCoach] = useService(CoachService.getTermForCoach);
    const [pageIndex, setPageIndex] = React.useState(0);
    const [personType, setPersonType] = React.useState(PersonTypeDomainService.StudentPersonTypeInternalName);
    const hasNextPage = React.useMemo(() => {
        return studentsByEngagementDateResponse.data
            ? studentsByEngagementDateResponse.data.length > PAGE_SIZE
            : false;
    }, [studentsByEngagementDateResponse]);
    const hasPrevPage = React.useMemo(() => {
        return pageIndex > 0;
    }, [pageIndex]);
    const isFiltered = React.useMemo(() => !!(filterSettings.registrationTerms &&
        filterSettings.registrationTerms.length), [filterSettings]);
    const nextPage = () => {
        setPageIndex((prevIndex) => prevIndex + 1);
    };
    const prevPage = () => {
        setPageIndex((prevIndex) => prevIndex - 1);
    };
    const [permissions, loadPermissions] = useService(React.useMemo(() => () => AdvisorService.getPermissions(), []));
    React.useEffect(() => {
        loadPermissions();
        loadTermToRepresentAdvisor();
        loadTermToRepresentCoach();
        loadCaseloadModalFilterResponse().then((result) => {
            setFilterSettings(EngagementService.getFilterSettingsFromRaw(result, false));
        });
    }, [
        loadCaseloadModalFilterResponse,
        loadPermissions,
        loadTermToRepresentAdvisor,
        loadTermToRepresentCoach,
    ]);
    React.useEffect(() => {
        if (caseloadModalFilterResponse.wasSuccessful &&
            caseloadModalFilterResponse.data) {
            const settings = EngagementService.getFilterSettingsFromRaw(caseloadModalFilterResponse.data, false);
            loadStudentsByEngagementDateResponse({
                keyEngagementAgeGreaterThanDays: settings.lastKeyEngagementMaxDaysAgo,
                registrationTermIds: settings.registrationTerms.map((term) => term.id),
                offset: pageIndex * PAGE_SIZE,
                max: PAGE_SIZE + 1,
                personType,
            });
        }
    }, [
        caseloadModalFilterResponse.data,
        caseloadModalFilterResponse.wasSuccessful,
        loadStudentsByEngagementDateResponse,
        pageIndex,
        personType,
    ]);
    React.useEffect(() => {
        if (caseloadModalFilterResponse.wasSuccessful &&
            caseloadModalFilterResponse.data) {
            const settings = EngagementService.getFilterSettingsFromRaw(caseloadModalFilterResponse.data, false);
            loadStudentsByEngagementDateResponse({
                keyEngagementAgeGreaterThanDays: settings.lastKeyEngagementMaxDaysAgo,
                registrationTermIds: settings.registrationTerms.map((term) => term.id),
                offset: pageIndex * PAGE_SIZE,
                max: PAGE_SIZE + 1,
                personType,
            });
        }
    }, [
        caseloadModalFilterResponse.data,
        caseloadModalFilterResponse.wasSuccessful,
        loadStudentsByEngagementDateResponse,
        pageIndex,
        personType,
    ]);
    React.useEffect(() => {
        setModalFilterSettings(Object.assign({}, filterSettings));
    }, [
        filterSettings.lastKeyEngagementMaxDaysAgo,
        filterSettings.teams,
        filterSettings.registrationTerms,
        filterSettings,
    ]);
    const saveFilterSettings = (settings) => {
        saveModalFilter(settings.lastKeyEngagementMaxDaysAgo, settings.registrationTerms);
        loadStudentsByEngagementDateResponse({
            keyEngagementAgeGreaterThanDays: settings.lastKeyEngagementMaxDaysAgo,
            registrationTermIds: settings.registrationTerms.map((term) => term.id),
            offset: pageIndex * PAGE_SIZE,
            max: PAGE_SIZE + 1,
            personType,
        });
    };
    return (_jsx(CaseloadKeyEngagementWidget, { isFiltered: isFiltered, studentsState: studentsByEngagementDateResponse, hasPrevPage: hasPrevPage, hasNextPage: hasNextPage, prevPage: prevPage, nextPage: nextPage, termToRepresentAdvisorState: termToRepresentAdvisorState, termToRepresentCoachState: termToRepresentCoachState, allStudentsState: allStudentsByEngagementDateResponse, allStudentsByEngagementDateResponse: allStudentsByEngagementDateResponse, getAllStudentsByEngagementDateResponse: (settings) => 
        // @ts-expect-error - TS2345 - Argument of type 'FilterSettings' is not assignable to parameter of type '{ keyEngagementAgeGreaterThanDays: number; registrationTermIds: string[]; }'.
        getAllStudentsByEngagementDateResponse(settings), filterSettings: filterSettings, setFilterSettings: setFilterSettings, modalFilterSettings: modalFilterSettings, setModalFilterSettings: setModalFilterSettings, saveFilterSettings: saveFilterSettings, pageSize: PAGE_SIZE, permissions: permissions }));
};
export default CaseloadKeyEngagementContainer;
